/// <amd-module name="Widgets/Burndown/BurndownWidget" />

import { LoadingStatus, WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { BurnDirection, BurndownViewComponentProps, ChangeFlags, WidgetFrameworkOperationId } from "./BurndownLegacyContracts";

import { ILegacyPlatformService } from "VSS/Legacy/Legacy";
import BurndownViewComponent from "./BurndownWidgetComponents/BurndownViewComponent";

export interface IWidgetSettings {}

// Legacy TFS Widget Contract

// Burndown Widget Contracts
interface BurndownWidgetState {
    burndownViewComponentType: any;
}

export interface IWidgetSettings {}

export class LegacyBurndownWidget extends VssComponent<WidgetProps, BurndownWidgetState> {
    public constructor(props: WidgetProps, context: IVssComponentContext) {
        super(props, context);
        this.state = { burndownViewComponentType: undefined };
    }

    public async componentDidMount() {
        const legacyService: ILegacyPlatformService = this.context.pageContext.getService("ILegacyPlatformService");
        legacyService.requireModules(["Widgets/Scripts/Burndown/BurndownViewComponentShim"]).then(burndownViewComponentType => {
            this.setState({ burndownViewComponentType: burndownViewComponentType });
        });
    }

    public render(): JSX.Element | null {
        const BurndownComponent = this.state.burndownViewComponentType;
        return BurndownComponent && BurndownComponent[0] ? React.createElement(BurndownComponent[0].default, this.generateBurndownProps()) : null;
    }

    protected getBurnDirection(): BurnDirection {
        return BurnDirection.Down;
    }

    /** Translate widget settings for the burndown widget to render via the "modern contract" */
    private generateBurndownProps(): BurndownViewComponentProps {
        const deferredRenderCompletion = {
            resolve: this.onRenderResolved,
            reject: this.onRenderFailed
        };
        return {
            burnDirection: this.getBurnDirection(),
            deferredRenderCompletion: deferredRenderCompletion,
            change: {
                operationId: WidgetFrameworkOperationId.reload,
                detectedChanges: ChangeFlags.all,
                widgetCreationOptions: {
                    typeId: this.props.contributionId,
                    getId: this.getWidgetId
                },
                config: {
                    name: this.props.name,
                    isLightBox: false, // THis drives legacy lightbox rendering behavior, we don't use.
                    sizeInPixels: this.props.size,
                    customSettings: {
                        data: this.props.settings!,
                        version: this.props.settingsVersion
                    },
                    sizeInGrid: {} as any // Burndown Sizes to content based on sizeInPixels
                }
            },
            suppressAnimations: !this.props.showLoadAnimations
        };
    }

    private onRenderResolved = (): void => {
        this.props.onWidgetLoaded();
    };

    private onRenderFailed = (error: string): void => {
        this.props.onWidgetLoaded({
            outcomeDescription: error,
            outcome: LoadingStatus.failure
        });
    };

    private getWidgetId = (): Promise<string> => {
        return Promise.resolve(this.props.id!);
    };
}

export class BurndownWidget extends VssComponent<WidgetProps, {}> {
    public render(): JSX.Element | null {
        return (
            <BurndownViewComponent
                {...this.props}
                burnDirection={this.getBurnDirection()}
                suppressAnimations={!this.props.showLoadAnimations}
                onRenderCompletion={this.props.onWidgetLoaded}
            />
        );
    }

    protected getBurnDirection(): BurnDirection {
        return BurnDirection.Down;
    }
}

export class BurndownWidgetRenderer extends VssComponent<WidgetProps, {}> {
    public render(): JSX.Element {
        return <BurndownWidget {...this.props} />;
    }
}

VssComponent.register("burndownWidget", BurndownWidgetRenderer);
